// extracted by mini-css-extract-plugin
export default {"solid":"tune-button-module__solid___vhIa1","outer":"tune-button-module__outer___joOoM"};